import React, { createContext, useContext } from 'react';
import { useFormPopup } from '../hooks/useFormPopup';
import FormPopup from '../components/FormPopup';

interface FormPopupContextValue {
  openFormPopup: () => void;
}

const FormPopupContext = createContext<FormPopupContextValue | undefined>(undefined);

export const FormPopupProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isFormPopupOpen, openFormPopup, closeFormPopup } = useFormPopup();

  return (
    <FormPopupContext.Provider value={{ openFormPopup }}>
      {children}
      {/* Render the popup once at the root level */}
      <FormPopup isOpen={isFormPopupOpen} onClose={closeFormPopup} />
    </FormPopupContext.Provider>
  );
};

export const useFormPopupContext = () => {
  const context = useContext(FormPopupContext);
  if (!context) {
    throw new Error('useFormPopupContext must be used within a FormPopupProvider');
  }
  return context;
}; 